// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".input--radios{align-items:center;display:flex;flex-wrap:wrap;margin-left:-.9375rem;margin-right:-.9375rem}.input--radios .input--radio{margin:0 .9375rem}.input--radios .input--radio.input--disabled{cursor:not-allowed}.input--radios .input--radio.input--disabled label{pointer-events:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
